module.exports = __webpack_public_path__ + "static/Karolína_Osickova_Iwillsurvive-eb9fe6a9ea000ae2be2c41a108b320f1.mp3";